var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlotBbin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162 100",
    style: {
      enableBackground: "new 0 0 162 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#BD9A61;}\n\t.st2{fill:#B90C13;}\n\t.st3{fill:#710000;}\n\t.st4{fill:url(#SVGID_00000005978453025679544300000007886322374628224385_);}\n\t.st5{clip-path:url(#SVGID_00000007399802271126486220000011096339436814396811_);}\n\t.st6{fill:#A50000;}\n\t.st7{fill:#F01E1E;}\n\t.st8{fill:url(#SVGID_00000041260655694146681530000017395687711306381466_);}\n\t.st9{fill:#5D0100;}\n\t.st10{fill:#CF0300;}\n\t.st11{fill:url(#SVGID_00000054262120574686524360000003942316522260506546_);}\n\t.st12{fill:url(#SVGID_00000038388200282477144460000006595641991503105706_);}\n\t.st13{fill:url(#SVGID_00000062888972550185130050000010097942797794588321_);}\n\t.st14{fill:url(#XMLID_00000170964887421850833430000008983037059160383380_);}\n\t.st15{fill:#191970;}\n\t.st16{fill:#FF6D2D;}\n\t.st17{fill:#FFFFFF;}\n\t.st18{fill:#E0E0E0;}\n\t.st19{fill:url(#SVGID_00000049219590724449615760000010123930536786409866_);}\n\t.st20{fill:#F16522;}\n\t.st21{fill:url(#SVGID_00000147181140103956135000000009494547489878486400_);}\n\t.st22{fill:url(#SVGID_00000175322439246585251110000008869824689753826740_);}\n\t.st23{clip-path:url(#SVGID_00000049189646864944601900000015393586404554058387_);}\n\t.st24{fill:#999999;}\n\t.st25{fill:url(#SVGID_00000103972040433881592090000005573998385573787530_);}\n\t.st26{fill:url(#SVGID_00000093863590820286963800000012615393396350537356_);}\n\t.st27{fill:#A7C738;}\n\t.st28{fill:#5866D4;}\n\t.st29{fill:url(#SVGID_00000170270358353229364630000010151516902301616055_);}\n\t.st30{fill:url(#SVGID_00000032611487123590399860000004665806220549870267_);}\n\t.st31{fill:url(#SVGID_00000088855920634018049580000004357602230383762363_);}\n\t.st32{fill:url(#SVGID_00000121258710809728857310000001158647894581320114_);}\n\t.st33{clip-path:url(#SVGID_00000047776503401889112120000006679051211364706211_);}\n\t.st34{fill:url(#SVGID_00000154418291444603341980000004537006129033463473_);}\n\t.st35{fill:url(#SVGID_00000060725738524847196410000008445802772323064208_);}\n\t.st36{fill:url(#SVGID_00000019666928658957875590000003912997417502596542_);}\n\t.st37{fill:url(#SVGID_00000135662611280918361110000008536504772096698536_);}\n\t.st38{fill:url(#XMLID_00000158027735695303468690000012879997730347675069_);}\n\t.st39{fill:#F3CD3F;}\n\t.st40{fill:#E81B24;}\n\t.st41{fill:#AB8B2F;}\n\t.st42{fill:#AE8F35;}\n\t.st43{fill:#CC1009;}\n\t.st44{fill:url(#SVGID_00000037691058994560108140000008194585608134958000_);}\n\t.st45{fill:url(#SVGID_00000090279078792840264430000016266743843657985977_);}\n\t.st46{fill:url(#SVGID_00000047741935722799903050000017197000399451814278_);}\n\t.st47{fill:#00DCF9;}\n\t.st48{fill:#2660B5;}\n\t.st49{fill:url(#SVGID_00000015340301541701728440000001256095038660307598_);}\n\t.st50{fill:url(#SVGID_00000046325034318406995520000008238120484423021234_);}\n\t.st51{fill:url(#SVGID_00000135667337358396230190000009530734814926354836_);}\n\t.st52{fill:url(#SVGID_00000072243568664604625230000009185406541031880078_);}\n\t.st53{fill:url(#SVGID_00000116218383298255832650000001524736292233412030_);}\n\t.st54{fill:url(#SVGID_00000107571549246014546780000000557505388239697853_);}\n\t.st55{fill:url(#SVGID_00000156545264397772372800000014844644419108798088_);}\n\t.st56{fill:url(#SVGID_00000073704547782301201060000008781164735223404436_);}\n\t.st57{fill:url(#SVGID_00000167368806951692080440000011525726576659809426_);}\n\t.st58{fill:url(#SVGID_00000105398567165279726140000003300346703889699768_);}\n\t.st59{fill:url(#SVGID_00000124163009012593426020000011697532438291719845_);}\n\t.st60{fill:url(#SVGID_00000093874367155817338430000011616678882529961124_);}\n\t.st61{fill:url(#SVGID_00000093893975439150996480000007097190452203728517_);}\n\t.st62{fill:url(#SVGID_00000071559876672147136920000001616551203130053001_);}\n\t.st63{fill:url(#SVGID_00000045586595525638991010000004766893072693809315_);}\n\t.st64{fill:url(#SVGID_00000047020612305992583890000007540174821758048898_);}\n\t.st65{fill:#EA292B;}\n\t.st66{fill:#010101;}\n\t.st67{fill:url(#SVGID_00000038401091087295937300000009607531514250352277_);}\n\t.st68{fill:url(#SVGID_00000051374085621187409690000016764251305765774728_);}\n\t.st69{fill:url(#SVGID_00000088092379652512685590000000880925667669892774_);}\n\t.st70{fill:url(#SVGID_00000018236251730144461820000004034888198640307868_);enable-background:new    ;}\n\t.st71{fill:url(#SVGID_00000132793272872584855610000013024680994137858487_);}\n\t.st72{fill:url(#SVGID_00000160903494914291235000000009345416405645113260_);}\n\t.st73{fill:url(#SVGID_00000056394805507606885720000002700838002737064064_);}\n\t.st74{fill:url(#SVGID_00000031907602742254920420000000775615981344396686_);enable-background:new    ;}\n\t.st75{fill:url(#SVGID_00000151535239577000625290000013806570948461701540_);}\n\t.st76{fill:url(#SVGID_00000035530282392673644420000016789941793244001672_);enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.43704,
    y1: 48.02697,
    x2: 118.43704,
    y2: 61.43917
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#881C19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C42822"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)",
      enableBackground: "new"
    },
    d: "M114.07198,47.57589v33.39787   c8.1769,0,8.73013-8.29836,8.73013-10.5517c0-0.36434,0-0.56673,0-0.56673V47.57589H114.07198z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000018924379391280486430000013056934245085566112_",
    cx: 186.52652,
    cy: 72.47726,
    r: 0.20404,
    gradientTransform: "matrix(0.95744 0 0 0.95744 -108.73521 -1.06407)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8261D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C02823"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000018924379391280486430000013056934245085566112_)"
    },
    points: "69.63869,68.15518    70.05698,68.506 69.63869,68.15518  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000059995872067833822760000014264507131354946225_",
    cx: -4066.56812,
    cy: 40.05111,
    r: 1.40931,
    gradientTransform: "matrix(56.44091 19.96256 -19.96256 56.44091 230404.125 78964.4375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8261D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C02823"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059995872067833822760000014264507131354946225_)"
    },
    d: "M114.73314,27.5135L114.73314,27.5135   l3.56222,3.52174l3.50825-3.52174c1.93683-1.94311,1.93683-5.08687,0-7.02998l0,0c-1.94128-1.94128-5.08871-1.94128-7.02998,0   c-1.94128,1.94128-1.94128,5.08871,0,7.02998l0,0H114.73314z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108295299632771655130000003055529794946364076_",
    gradientUnits: "userSpaceOnUse",
    x1: -4029.2688,
    y1: -215.38773,
    x2: -4027.91968,
    y2: -215.38773,
    gradientTransform: "matrix(4.83 13.23 -13.23 4.83 16669.33789 54404.83984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B5B5B6"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000108295299632771655130000003055529794946364076_)"
    },
    points: "54.24289,48.21215    54.24289,48.21215 54.2294,48.22564 54.2294,48.22564 54.24289,48.21215  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183929310645304044720000012574580381257918852_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.75338,
    y1: 46.93839,
    x2: 60.75338,
    y2: 28.269
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#881C19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51674,
    style: {
      stopColor: "#C42822"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183929310645304044720000012574580381257918852_)",
      enableBackground: "new"
    },
    d: "   M114.0045,34.63794v14.2912l7.50224-4.72133v-4.99566C120.20882,36.2684,117.21581,34.44352,114.0045,34.63794 M54.2294,19.02625   v29.18591l0,0l0.3152,0.01349l8.38977-8.09262l-0.00182-0.61053v-9.37781l0,0c0,0,0-0.2024,0-0.56672   C62.97302,27.3111,62.40631,19.02625,54.2294,19.02625 M0.00002,19.02625 M0.00002,19.02625v37.64617l0,0   c-0.0069-2.99567,8.45712-18.34173,8.71664-18.58021l0,0v-7.94753l0,0c0,0,0-0.2024,0-0.56672   C8.73015,27.3111,8.17693,19.02625,0.00002,19.02625"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000049182307720514153030000006692277173838485644_",
    cx: -4036.89282,
    cy: 63.2903,
    r: 1.37152,
    gradientTransform: "matrix(43.60168 0 0 43.60168 176098 -2703.14282)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8261D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C02823"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049182307720514153030000006692277173838485644_)"
    },
    d: "M0.00002,56.67242L0.00002,56.67242   C-0.00031,69.967,10.77682,80.74464,24.07139,80.74497c6.38794,0.00015,12.51399-2.53874,17.02907-7.05756l8.56821-8.56821   c-1.83727-0.75133-3.80366-1.13636-5.78861-1.13344c-3.33979-0.04267-6.56079,1.23797-8.95952,3.56222   c-2.92717,2.87659-6.85279,4.51066-10.95652,4.56072c-4.06619-0.01464-7.95588-1.6629-10.7946-4.57421   c-2.86518-2.86319-4.48059-6.74406-4.49325-10.7946l0,0l0,0c-0.01546-4.02447,1.55522-7.89301,4.37181-10.76762l0.44528-0.44528   c6.04148-5.72158,15.53922-5.59598,21.42728,0.28336l13.95202,13.93853l13.93853,13.93853   c4.50389,4.51698,10.62278,7.05195,17.0015,7.04348l0,0c6.35133,0.01033,12.44879-2.49268,16.96102-6.96252l17.23087-15.81409l0,0   l7.29984-6.74663l1.34933-1.34932l4.35832-4.04798l0.13493-0.12144c2.85899-2.87144,6.74257-4.48798,10.7946-4.49326l0,0   c8.47215,0.01487,15.33441,6.88315,15.34183,15.35532v14.32983c0.09445,2.83358,1.11995,9.97151,8.71664,9.97151v-24.1799   c-0.09462-13.30169-10.95448-24.00814-24.25618-23.91351c-6.02931,0.04289-11.82325,2.34563-16.23708,6.45324l0,0l-7.50224,6.90855   l0,0l-10.16042,9.32384l0,0L90.86357,67.37257l0,0l0,0l-0.13493,0.13493c-6.00219,5.97841-15.70846,5.97841-21.71065,0   l0.64767,0.6072l-0.66117-0.62069L55.03899,53.58247l0,0L41.08697,39.64394c-8.79561-8.77014-22.81624-9.41859-32.3838-1.49775l0,0   c-0.49925,0.41829-0.9985,0.83658-1.47076,1.34933l-0.48576,0.45877c-4.33393,4.47462-6.75396,10.46177-6.74663,16.69115l0,0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035509071116184054570000017136419343965825200_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.16505,
    y1: 66.85276,
    x2: 69.54162,
    y2: 36.40065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02136,
    style: {
      stopColor: "#881C19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53183,
    style: {
      stopColor: "#D4261E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CC2720"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035509071116184054570000017136419343965825200_)",
      enableBackground: "new"
    },
    d: "   M79.85308,32.61395c-6.31449,0.00243-12.41625,2.48315-16.92054,6.90855l-8.70315,8.68966   c1.83786,0.74933,3.83084,1.13428,5.81559,1.13343c3.34007,0.04415,6.5616-1.23671,8.95951-3.56222   c2.93634-2.83585,6.84757-4.43897,10.92954-4.47976c8.42129,0.11728,15.20293,6.9469,15.26086,15.36881   c0.00429,3.99458-1.54961,7.83332-4.33134,10.70015l12.98051-11.92803C103.23124,42.64682,92.66544,32.59208,79.85308,32.61395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotBbin);
export default __webpack_public_path__ + "static/media/slot-bbin.4378d0113af335efdbf949eca53f6d35.svg";
export { ForwardRef as ReactComponent };